import { useAdjustButtonContext } from './Context'
import { BusyButtonLink } from '@ztechapps/webui.button'
import React from 'react'
import { useBillOfMaterialsContext } from '../Context'
import type { AdjustmentProps } from '@ztechapps/webui.contract'
import { useInjectComponent, WebuiIocKey } from '@ztechapps/webui.contract'
import { Modal, ModalDragHandle } from '@ztechapps/webui.modal'

export const Layout = () => {
  const Adjustment = useInjectComponent<AdjustmentProps>(WebuiIocKey.adjustment.adjustment)
  const { product, qtyNeededToBuild, onAfterAction } = useAdjustButtonContext()
  const { canEdit } = useBillOfMaterialsContext()
  return (
    <Modal
      centered
      size="md"
      trigger={({ onClick }) => (
        <BusyButtonLink onClick={onClick} icon="circle-half-stroke" title="Add an adjustment to this product." />
      )}
    >
      {({ toggleShowModal }) => (
        <>
          <ModalDragHandle>Adjust quantity</ModalDragHandle>
          <Adjustment
            product={product}
            canEdit={canEdit}
            afterAdjustment={() => {
              toggleShowModal()
              onAfterAction?.()
            }}
            qtyToAdjust={qtyNeededToBuild}
          />
        </>
      )}
    </Modal>
  )
}
